module.exports = __webpack_public_path__ + "img/1-md.cabd37b4.jpg";